import React, { Component } from 'react'

export default class ToolBackground extends Component {
  render() {
    return <div className={'tool-background'} id="tool-background"></div>
  }
}
